import { JSONClient } from "./bootstrap";
import store from "../store";

export const getRandomTip = async () => {
  try {
    const response = await JSONClient.get("/home/tip", {
      headers: {
        Authorization:
          store.getters["userStore/getAuthToken"],
      },
    });
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const getBots = async () => {
  try {
    const response = await JSONClient.get("/tools/bots", {
      headers: {
        Authorization:
          store.getters["userStore/getAuthToken"],
      },
    });
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const getLibs = async () => {
  try {
    const response = await JSONClient.get("/tools/library", {
      headers: {
        Authorization:
          store.getters["userStore/getAuthToken"],
      },
    });
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const getSponsored = async () => {
  try {
    const response = await JSONClient.get("/tools/sponsored", {
      headers: {
        Authorization:
          store.getters["userStore/getAuthToken"],
      },
    });
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};
